/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { MutableRefObject, ReactNode } from 'react';

import type { Button } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import Pill from 'bundles/browse-common/components/Pill/Pill';

type TrackingData = {
  button: Button;
};

type TrackedPillProps = {
  children: ReactNode;
  trackingData: TrackingData;
  className?: string;
  dataTestId?: string;
} & ({ href: string } | { onClick: () => void });

const TrackedPill = ({ children, trackingData, className, dataTestId, ...props }: TrackedPillProps) => {
  const track = useTracker();
  const ref: MutableRefObject<HTMLButtonElement | null> = useVisibilityTracker('view_button', trackingData);

  const trackClick = () => {
    track('click_button', trackingData);
    if ('onClick' in props) {
      props.onClick();
    }
  };

  return (
    <Pill
      ref={ref}
      href={'href' in props ? props.href : ''}
      onClick={trackClick}
      className={className}
      data-testid={dataTestId}
    >
      {children}
    </Pill>
  );
};

export default TrackedPill;
